import React, { useState, useEffect, useCallback } from 'react';
// import { useParams } from 'react-router-dom';
import Editor from '@monaco-editor/react';
import axiosInstance from 'api/axiosInstance';
import apiUrls from 'api/apiUrls';
import JSZip from 'jszip';
import InterfaceSelect from 'components/select';
import {
  Box,
  Flex,
  Button,
  // Text,
  // useDisclosure,
  // Select,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useColorModeValue,
  useColorMode,
  useToast,
  Heading,
  Text,
} from '@chakra-ui/react';
import FileExplorer from './FileExplorer';
import Card from 'components/card/Card';
// import { useNavigate } from 'react-router-dom';
import { Skeleton, SkeletonText } from '@chakra-ui/react';
// import { useLocation } from 'react-router-dom';
import GlobalAlertDialog from 'components/GlobalAlertDialog';
import { useNavigate } from 'react-router-dom';
import Sidebar from 'components/sidebar/Sidebar';
import BreadCrumb from 'components/breadCrumb/BreadCrumb';

const PLATFORM_ID = process.env.REACT_APP_PLATFORM_ID;

const NameModal = ({
  isOpen,
  onClose,
  title,
  placeholder,
  value,
  onChange,
  onConfirm,
  confirmLabel = 'Confirm',
  isConfirmDisabled = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg={useColorModeValue('white', 'navy.700')}>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            color={useColorModeValue('navy.700', 'white')}
            placeholder={placeholder}
            autoFocus
            value={value}
            onChange={onChange}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={onConfirm}
            isDisabled={isConfirmDisabled}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const Logic2 = () => {
  const breadcrumbItems = [
    { label: 'Home', path: '/dashboard' },
    { label: 'Add new patch', path: '' },
  ];
  const toast = useToast();
  const groupId = localStorage.getItem('groupID');
  const { colorMode } = useColorMode();
  // const navigate = useNavigate();
  // const { deviceUUID } = useParams();

  const [patchNameModalOpen, setPatchNameModalOpen] = useState(false);

  const [pythonCode, setPythonCode] = useState('');
  const [files, setFiles] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [editorTheme, setEditorTheme] = useState(
    useColorModeValue('vs-light', 'vs-dark'),
  );
  const [pendingSaveAction, setPendingSaveAction] = useState(null);

  useEffect(() => {
    const newTheme = colorMode === 'dark' ? 'vs-dark' : 'vs-light';
    setEditorTheme(newTheme);
  }, [colorMode]);

  // Wrap generateId in useCallback to stabilize its reference
  const generateId = useCallback(
    () => `id_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const [loading, setLoading] = useState(true);
  const [patchName, setPatchName] = useState('');
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  const sidebarExpandedWidth = '260px';
  const sidebarCollapsedWidth = '80px';
  const sidebarWidth = collapsed ? sidebarCollapsedWidth : sidebarExpandedWidth;

  const panelBg = useColorModeValue('white', 'navy.700');
  const optionText = useColorModeValue('navy.800', 'white');

  // Rename Modal state
  const [renameState, setRenameState] = useState({
    isOpen: false,
    item: null,
    newName: '',
  });
  // Delete confirmation state
  const [deleteState, setDeleteState] = useState({ isOpen: false, item: null });
  // Create file modal state
  const [createFileState, setCreateFileState] = useState({
    isOpen: false,
    parent: null,
    fileName: '',
  });
  // Create folder modal state
  const [createFolderState, setCreateFolderState] = useState({
    isOpen: false,
    parent: null,
    folderName: '',
  });

  // useEffect(() => {
  //   console.log(editorTheme)
  // }, [editorTheme]);

  // const handleUploadClick = () => {
  //   setPatchNameModalOpen(true);
  // };

  // Wrap initializeDefault in useCallback
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(collapsed));
  }, [collapsed]);
  const initializeDefault = useCallback(() => {
    const projectFolderId = generateId();
    const mainFileId = generateId();
    const reqFileId = generateId();
    const versionFileId = generateId();

    const struct = [
      {
        id: projectFolderId,
        name: 'Project',
        type: 'folder',
        parentId: null,
      },
      {
        id: mainFileId,
        name: 'main.py',
        type: 'file',
        content: '',
        parentId: projectFolderId,
      },
      {
        id: reqFileId,
        name: 'requirements.txt',
        type: 'file',
        content: '',
        parentId: projectFolderId,
      },
      {
        id: versionFileId,
        name: 'version.txt',
        type: 'file',
        content: 'v1', // Set default version to 'v1'
        parentId: projectFolderId,
      },
    ];

    setFiles(struct);
    setSelectedFile(struct[1]);
    setPythonCode(struct[1].content);

    return struct;
  }, [generateId, setFiles, setSelectedFile, setPythonCode]);

  // Move fillData function inside Logic component and wrap in useCallback
  // Move fillData above fetchPatchDetails and fetchConfigurations

  // Move fetchConfigurations above useEffect that uses it
  const fetchConfigurations = useCallback(async () => {
    initializeDefault();
    setLoading(false);
  }, [initializeDefault]);

  // const fetchPatchDetails = useCallback(async () => {
  //   if (!patchId) return;

  //   try {
  //     const keys = 'patch,patch_v,patch_name,patch_id';
  //     const resp = await axiosInstance.get(
  //       apiUrls.getPatchData(deviceId, keys),
  //     );
  //     await fillData(resp);
  //   } catch (err) {
  //     console.error('Failed to fetch file explorer:', err);
  //     initializeDefault();
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [patchId, fillData, initializeDefault, deviceId]);

  // Move fetchPatches above its first use

  // useEffect(() => {
  //   if (patchId) {
  //     fetchPatchDetails();
  //   }
  // }, [patchId, fetchPatchDetails]);

  useEffect(() => {
    fetchConfigurations();
  }, [fetchConfigurations]);

  // Rename handlers
  const openRename = (item) =>
    setRenameState({ isOpen: true, item, newName: item.name });
  const closeRename = () =>
    setRenameState({ isOpen: false, item: null, newName: '' });
  const handleRenameConfirm = () => {
    if (renameState.newName.trim()) {
      setFiles((prev) =>
        prev.map((f) =>
          f.id === renameState.item.id
            ? { ...f, name: renameState.newName.trim() }
            : f,
        ),
      );
      if (selectedFile?.id === renameState.item.id) {
        setSelectedFile({
          ...renameState.item,
          name: renameState.newName.trim(),
        });
      }
    }
    closeRename();
  };

  // Delete handlers
  const openDelete = (item) => setDeleteState({ isOpen: true, item });
  const closeDelete = () => setDeleteState({ isOpen: false, item: null });
  const handleDeleteConfirm = () => {
    setFiles((prev) => prev.filter((f) => f.id !== deleteState.item.id));
    if (selectedFile?.id === deleteState.item.id) {
      setSelectedFile(null);
      setPythonCode('');
    }
    closeDelete();
  };

  // Create file handlers
  const openCreateFile = (parent) =>
    setCreateFileState({ isOpen: true, parent, fileName: '' });
  const closeCreateFile = () =>
    setCreateFileState({ isOpen: false, parent: null, fileName: '' });
  const handleCreateFileConfirm = () => {
    const nm = createFileState.fileName.trim();
    if (nm) {
      const id = generateId();
      const f = {
        id,
        name: nm,
        type: 'file',
        content: '',
        parentId: createFileState.parent?.id || null,
      };
      setFiles((prev) => [...prev, f]);
      setSelectedFile(f);
      setPythonCode('');
    }
    closeCreateFile();
  };

  // Create folder handlers
  const openCreateFolder = (parent) =>
    setCreateFolderState({ isOpen: true, parent, folderName: '' });
  const closeCreateFolder = () =>
    setCreateFolderState({ isOpen: false, parent: null, folderName: '' });
  const handleCreateFolderConfirm = () => {
    const nm = createFolderState.folderName.trim();
    if (nm) {
      const id = generateId();
      const f = {
        id,
        name: nm,
        type: 'folder',
        parentId: createFolderState.parent?.id || null,
      };
      setFiles((prev) => [...prev, f]);
    }
    closeCreateFolder();
  };

  const handleImportFile = (file, parentFolder = null) => {
    const reader = new FileReader();
    reader.onload = () => {
      const content = reader.result;
      const id = generateId();
      const newFile = {
        id,
        name: file.name,
        type: 'file',
        content,
        parentId: parentFolder?.id || null,
      };
      setFiles((prev) => [...prev, newFile]);
      setSelectedFile(newFile);
      setPythonCode(content);
    };
    reader.readAsText(file);
  };

  const handleFolderImport = (fileList, parentFolder = null) => {
    const folderMap = {}; // To track created folders and their IDs

    // Get root folder name from the first file
    const firstFile = fileList[0];
    const fullPath = firstFile?.webkitRelativePath || firstFile?.name;
    const baseFolderName = fullPath?.split('/')?.[0];

    // Create the root folder (if not already passed as parentFolder)
    let rootFolderId = parentFolder?.id || null;

    if (!parentFolder && baseFolderName) {
      rootFolderId = generateId();
      const rootFolder = {
        id: rootFolderId,
        name: 'Project',
        type: 'folder',
        parentId: null,
      };
      setFiles((prev) => [...prev, rootFolder]);
      folderMap[baseFolderName] = rootFolderId;
    }

    const createFolder = (folderPath) => {
      if (folderMap[folderPath]) return folderMap[folderPath];

      const parts = folderPath.split('/');
      const folderName = parts[parts.length - 1];
      const parentPath = parts.slice(0, -1).join('/');
      const parentId = parentPath ? createFolder(parentPath) : rootFolderId;

      const id = generateId();
      const newFolder = {
        id,
        name: folderName,
        type: 'folder',
        parentId,
      };

      setFiles((prev) => [...prev, newFolder]);
      folderMap[folderPath] = id;
      return id;
    };

    Array.from(fileList).forEach((file) => {
      const relativePath = file.webkitRelativePath || file.name;
      const cleanPath = parentFolder
        ? relativePath
        : relativePath.replace(`${baseFolderName}/`, '');

      const pathParts = cleanPath.split('/');

      const reader = new FileReader();
      reader.onload = () => {
        const content = reader.result;
        const id = generateId();

        let parentId = rootFolderId;

        if (pathParts.length > 1) {
          const folderPath = pathParts.slice(0, -1).join('/');
          parentId = createFolder(folderPath);
        }

        const newFile = {
          id,
          name: file.name,
          type: 'file',
          content,
          parentId,
        };

        setFiles((prev) => [...prev, newFile]);
        setSelectedFile(newFile);
        setPythonCode(content);
      };

      reader.readAsText(file);
    });
  };
  const handlePublishOrDraft = (action) => {
    setPendingSaveAction(action);
    setPatchName('');
    setPatchNameModalOpen(true);
  };
  const handlePatchNameConfirm = async (saveAction) => {
    const trimmedName = patchName.trim();
    if (!trimmedName) return;

    setPatchNameModalOpen(false);
    const result = await uploadZipToServer(trimmedName, saveAction);
    if (result !== false) {
      navigate('/patches');
    }
  };
  const uploadZipToServer = async (versionStr, saveAction) => {
    const hasMain = files.some(
      (f) => f.type === 'file' && f.name === 'main.py',
    );
    const hasRequirements = files.some(
      (f) => f.type === 'file' && f.name === 'requirements.txt',
    );
    // Check for version.txt existence and content
    const versionFile = files.find(
      (f) => f.type === 'file' && f.name === 'version.txt',
    );
    if (!hasMain || !hasRequirements) {
      toast({
        title: 'Missing Required Files',
        description:
          "Make sure 'main.py' and 'requirements.txt' exist before uploading.",
        status: 'warning',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    if (!versionFile || !versionFile.content || !versionFile.content.trim()) {
      toast({
        title: 'Missing Version',
        description: "The 'version.txt' file must not be empty.",
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    // Validate version.txt format: must be v1, v2, etc.
    if (!/^v\d+$/i.test(versionFile.content.trim())) {
      toast({
        title: 'Invalid Version Format',
        description:
          "The 'version.txt' file must be in the format 'v1', 'v2', etc.",
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const versionMatch = versionStr.match(/v?(\d+)/i);
    const patchVersion = versionMatch ? parseInt(versionMatch[1], 10) : 1;

    const zip = new JSZip();
    const buildZipTree = (currentFolder, parent) => {
      const children = files.filter(
        (f) => f.parentId === (parent ? parent.id : null),
      );
      for (const item of children) {
        if (item.type === 'file') {
          currentFolder.file(item.name, item.content || '');
        } else if (item.type === 'folder') {
          const newFolder = currentFolder.folder(item.name);
          buildZipTree(newFolder, item);
        }
      }
    };
    buildZipTree(zip, null);

    try {
      const blob = await zip.generateAsync({ type: 'blob' });
      const arrayBuffer = await blob.arrayBuffer();
      const base64Data = btoa(
        new Uint8Array(arrayBuffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          '',
        ),
      );

      const payload = {
        apply_to_devices: saveAction === 'publish' ? 1 : 0,
        content: base64Data,
        version: patchVersion,
        patch_id: '',
        patch_name: patchName,
      };
      await axiosInstance.post(
        apiUrls.updatePatch(PLATFORM_ID, groupId),
        payload,
      );

      toast({
        title:
          saveAction === 'publish'
            ? 'Upload Successful'
            : 'Draft Saved Successfully',
        description:
          saveAction === 'publish'
            ? 'Files zipped and uploaded successfully.'
            : 'Patch saved as draft successfully.',
        status: 'success',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
    } catch (err) {
      console.error('Upload failed:', err);
      let errorMsg = 'An error occurred while uploading the zip.';
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          errorMsg = err.response.data;
        } else if (err.response.data.error) {
          errorMsg = err.response.data.error;
        } else if (err.response.data.message) {
          errorMsg = err.response.data.message;
        } else {
          errorMsg = JSON.stringify(err.response.data);
        }
      } else if (err.message) {
        errorMsg = err.message;
      }
      toast({
        title: 'Upload Failed',
        description: errorMsg,
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return false;
    }
  };

  // Themes options
  const themes = {
    'Light (vs-light)': 'vs-light',
    'Dark (vs-dark)': 'vs-dark',
    'High Contrast Dark': 'hc-black',
    'High Contrast Light': 'hc-light',
    'Solarized Light': 'solarized-light',
  };

  return (
    <>
      <Flex
        h="auto"
        align="center"
        justify="flex-end"
        color={optionText}
        fontSize="lg"
        px={4}
        mb={4}
      >
        {/* <FormControl w="200px" mr={4}>
          <FormLabel fontSize="sm">Select Logic</FormLabel>
          <InterfaceSelect
            value={patchId}
            onChange={(val) => setPatchId(val)}
            options={patchConfigMap}
          />
        </FormControl> */}
        {/* <Button
          mt={8}
          size="sm"
          colorScheme="green"
          variant="outline"
          border="2px"
          cursor="pointer"
          onClick={() => {
            navigate(location.pathname, { state: { activeTab: 4 } });
          }}
        >
          Add New Logic
        </Button> */}
      </Flex>
      <Flex ml={1} mt={6} direction="column" h="100vh">
        <BreadCrumb items={breadcrumbItems} sidebarWidth={sidebarWidth} />

        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Heading size="lg" mb={6} ml={sidebarWidth}>
          Add Patch
        </Heading>
        <Flex flex="1" overflow="hidden">
          {/* File Explorer Panel */}

          <Card
            minW="250px"
            maxW="25%"
            ml={sidebarWidth}
            bg={panelBg}
            width={`calc(100% - ${sidebarWidth})`}
            p={4}
            overflowY="auto"
            me={3}
            flexShrink={0}
          >
            {loading ? (
              <>
                <Skeleton height="40px" mb={4} />
                <SkeletonText noOfLines={10} spacing="4" />
              </>
            ) : (
              <>
                <Flex gap={2} mb={4}>
                  <Button
                    colorScheme="green"
                    onClick={() => handlePublishOrDraft('publish')}
                  >
                    Publish
                  </Button>
                  <Button
                    colorScheme="blue"
                    variant="outline"
                    onClick={() => handlePublishOrDraft('draft')}
                  >
                    Save as Draft
                  </Button>
                </Flex>
                <FileExplorer
                  files={files}
                  selectedFile={selectedFile}
                  onFileSelect={(f) => {
                    setSelectedFile(f);
                    setPythonCode(f.content || '');
                  }}
                  onRenameItem={openRename}
                  onDeleteItem={openDelete}
                  onCreateFile={openCreateFile}
                  onCreateFolder={openCreateFolder}
                  onImportFile={handleImportFile}
                  onImportFolder={handleFolderImport}
                />
              </>
            )}
          </Card>

          {/* Editor Panel */}
          <Box
            flex="1"
            pt={6}
            h="100%"
            bg={panelBg}
            borderRadius="md"
            overflow="hidden"
          >
            {loading ? (
              <Skeleton height="100%" />
            ) : selectedFile && selectedFile.type === 'file' ? (
              <>
                <Box mb={4}>
                  <Flex
                    h="auto"
                    align="center"
                    justify="space-around"
                    color={optionText}
                    fontSize="lg"
                    px={4}
                    pb={2}
                  >
                    <FormControl w="200px">
                      <FormLabel fontSize="sm">Editor Theme</FormLabel>
                      <InterfaceSelect
                        value={editorTheme}
                        onChange={(val) => setEditorTheme(val)}
                        options={themes}
                      />
                    </FormControl>
                  </Flex>
                </Box>
                <Editor
                  language="python"
                  theme={editorTheme}
                  value={pythonCode}
                  onChange={(value) => {
                    setPythonCode(value);
                    setFiles((prev) =>
                      prev.map((f) =>
                        f.id === selectedFile.id ? { ...f, content: value } : f,
                      ),
                    );
                  }}
                  options={{
                    fontSize: 14,
                    minimap: { enabled: false },
                    automaticLayout: true,
                  }}
                  height="100%"
                />
              </>
            ) : (
              <Flex
                h="100%"
                align="center"
                justify="center"
                color={optionText}
                fontSize="lg"
              >
                Select a file to edit
              </Flex>
            )}
          </Box>
        </Flex>

        <NameModal
          isOpen={renameState.isOpen}
          onClose={closeRename}
          title={`Rename ${renameState.item?.type}`}
          placeholder="Enter new name"
          value={renameState.newName}
          onChange={(e) =>
            setRenameState((s) => ({ ...s, newName: e.target.value }))
          }
          onConfirm={handleRenameConfirm}
          isConfirmDisabled={!renameState.newName.trim()}
        />

        {/* Delete Confirmation */}
        <GlobalAlertDialog
          isOpen={deleteState.isOpen}
          onClose={closeDelete}
          onConfirm={handleDeleteConfirm}
          title={`Delete ${deleteState.item?.type}`}
          body={
            <>
              Are you sure you want to delete <b>{deleteState.item?.name}</b>?
              This action cannot be undone.
            </>
          }
          confirmText="Delete"
          cancelText="Cancel"
          showCancel={true}
        />

        {/* Create file handlers */}
        <NameModal
          isOpen={createFileState.isOpen}
          onClose={closeCreateFile}
          title="Create New File"
          placeholder="File name"
          value={createFileState.fileName}
          onChange={(e) =>
            setCreateFileState((s) => ({ ...s, fileName: e.target.value }))
          }
          onConfirm={handleCreateFileConfirm}
          isConfirmDisabled={!createFileState.fileName.trim()}
        />

        {/* Create Folder Modal */}
        <NameModal
          isOpen={createFolderState.isOpen}
          onClose={closeCreateFolder}
          title="Create New Folder"
          placeholder="Folder name"
          value={createFolderState.folderName}
          onChange={(e) =>
            setCreateFolderState((s) => ({ ...s, folderName: e.target.value }))
          }
          onConfirm={handleCreateFolderConfirm}
          isConfirmDisabled={!createFolderState.folderName.trim()}
        />
        <NameModal
          isOpen={patchNameModalOpen}
          onClose={() => {
            setPatchNameModalOpen(false);
            setPendingSaveAction(null);
          }}
          title="Patch Name"
          placeholder="New patch name"
          value={patchName}
          onChange={(e) => setPatchName(e.target.value)}
          onConfirm={() =>
            handlePatchNameConfirm(pendingSaveAction || 'publish')
          }
          confirmLabel={
            pendingSaveAction === 'draft' ? 'Save as Draft' : 'Publish'
          }
          isConfirmDisabled={!patchName.trim()}
        />
      </Flex>
      <Flex
        as="footer"
        position="fixed"
        left={0}
        bottom="0"
        width="100%"
        bg={useColorModeValue('gray.100', 'navy.800')}
        color={useColorModeValue('gray.600', 'gray.200')}
        py={2}
        px={4}
        align="center"
        justify="space-between"
        zIndex={20} // higher than sidebar
        borderTop="1px solid"
        borderColor={useColorModeValue('gray.200', 'gray.700')}
        boxShadow="0 -2px 8px rgba(0,0,0,0.04)"
      >
        <Text fontSize="sm" fontWeight="medium">
          Version 1.0.0
        </Text>
        <Text fontSize="sm" fontWeight="medium">
          UGX Systems
        </Text>
      </Flex>
    </>
  );
};

export default Logic2;
